<section class="bg-(--color-secondary) min-h-screen -mt-10 pb-10">
  <!-- Footer content -->
  <div class="footer-content grid grid-cols-1 lg:grid-cols-4 gap-x-16 py-16 px-16">
    <!-- Column 1 -->
    <div class="right-content">
      <img src="/images/logo-plain.png" alt="Awalan-logo" class="w-32 h-16" />

      <p class="right-p mt-6">
        خبرة تمتد لأكثر من 20 عامًا نضمن من خلالها تقديم أفضل التوجيهات <br />والحلول الزراعية.
      </p>
    </div>

    <!-- Column 2 -->
    <div class="lg:ms-12">
      <h4 class="footer-title">الشركة</h4>
      <ul class="footer-list">
        <li class="footer-link">
          <img src="/images/logo-tab.png" class="link-icon" />
          <a routerLink="/">الرئيسية</a>
        </li>
        <li class="footer-link">
          <img src="/images/logo-tab.png" class="link-icon" />
          <a routerLink="/about">من نحن</a>
        </li>
        <li class="footer-link">
          <img src="/images/logo-tab.png" class="link-icon" />
          <a routerLink="/projects">المشاريع</a>
        </li>
        <li class="footer-link">
          <img src="/images/logo-tab.png" class="link-icon" />
          <a routerLink="/contact-us">اتصل بنا</a>
        </li>
      </ul>
    </div>

    <!-- Column 3 -->
    <div>
      <h4 class="footer-title">الدعم</h4>
      <ul class="footer-list">
        <li class="footer-link">
          <img src="/images/logo-tab.png" class="link-icon" />
          <a routerLink="/faq">الأسئلة الشائعة</a>
        </li>
        <li class="footer-link">
          <img src="/images/logo-tab.png" class="link-icon" />
          <a routerLink="/help-center">مركز المساعدة</a>
        </li>
        <li class="footer-link">
          <img src="/images/logo-tab.png" class="link-icon" />
          <a routerLink="/contractor-guide">دليل المتعاقد</a>
        </li>

        <li class="footer-link">
          <img src="/images/logo-tab.png" class="link-icon" />
          <a routerLink="/technical-support">اتصل بالدعم الفني</a>
        </li>
      </ul>
    </div>

    <!-- Column 4 -->
    <div>
      <h4 class="footer-title">قانوني</h4>
      <ul class="footer-list">
        <li class="footer-link">
          <img src="/images/logo-tab.png" class="link-icon" />
          <a routerLink="/terms-of-use">شروط الاستخدام</a>
        </li>
        <li class="footer-link">
          <img src="/images/logo-tab.png" class="link-icon" />
          <a routerLink="/privacy-policy">سياسة الخصوصية</a>
        </li>

        <li class="footer-link">
          <img src="/images/logo-tab.png" class="link-icon" />
          <a routerLink="/refund-policy">سياسة استرداد الأموال</a>
        </li>

        <li class="footer-link">
          <img src="/images/logo-tab.png" class="link-icon" />
          <a routerLink="/disclaimer">إخلاء المسؤولية</a>
        </li>
      </ul>
    </div>
  </div>

  <div
    class="footer-bottom flex flex-col lg:flex-row md:justify-between items-start md:items-center "
  >
    <div class="footer-copyright px-10 lg:text-start text-center">
      <p>للاستثمار الزراعي – جميع الحقوق محفوظة Awalan</p>
      <p>2026 <sup>&copy;</sup></p>
    </div>

    <div class="social-links">
      <ul
        class="flex flex-row-reverse items-center md:gap-4 gap-1 text-white pe-[clamp(22rem,28vw,30rem)] md:pe-0 "
      >
        <li>
          <a
            href="#"
            class="w-10 h-10 rounded-full bg-(--color-secondary) flex items-center justify-center hover:bg-(--color-secondary) transition"
          >
            <i class="fa-brands fa-instagram text-lg"></i>
          </a>
        </li>

        <li>
          <a
            href="#"
            class="w-10 h-10 rounded-full bg-(--color-secondary) flex items-center justify-center hover:bg-(--color-secondary) transition"
          >
            <i class="fa-brands fa-pinterest-p text-lg"></i>
          </a>
        </li>

        <li>
          <a
            href="#"
            class="w-10 h-10 rounded-full bg-(--color-secondary) flex items-center justify-center hover:bg-(--color-secondary) transition"
          >
            <i class="fa-brands fa-twitter text-lg"></i>
          </a>
        </li>

        <li>
          <a
            href="#"
            class="w-10 h-10 rounded-full bg-(--color-secondary) flex items-center justify-center hover:bg-(--color-secondary) transition"
          >
            <i class="fa-brands fa-facebook-f text-lg"></i>
          </a>
        </li>

        <h3 class="mr-4 text-(--color-secondary)">تابعنا</h3>
      </ul>
    </div>
  </div>
</section>
